import { render, staticRenderFns } from "./InfectionTraceInfoTxt.vue?vue&type=template&id=5d0396cc&"
import script from "./InfectionTraceInfoTxt.vue?vue&type=script&lang=ts&"
export * from "./InfectionTraceInfoTxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports